export const MEMBERSHIP_CATEGORIES = [
  { label: "个人版会员", value: "personal" },
  { label: "团队版会员", value: "team" },
  { label: "算力充值", value: "power" }
] as const;

/** 月付、年付徽标取三档该周期最低折扣，见 memberCard/skus */
export const PERSONAL_PERIODS = [
  { label: "尝鲜试用", value: "trial", badge: "19.9元", hot: true },
  { label: "月付", value: "month", badge: "低至7.9折", hot: false },
  { label: "季付", value: "season", badge: "", hot: false },
  { label: "年付", value: "year", badge: "低至7折", hot: false }
] as const;

export type MembershipCategory = (typeof MEMBERSHIP_CATEGORIES)[number]["value"];
export type OfferPeriod = (typeof PERSONAL_PERIODS)[number]["value"];
